/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Stat_MultipanelInputs */

const tr_landing_shortcuts_stat_multipanel = /** @type {(inputs: Landing_Shortcuts_Stat_MultipanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`çoklu panel araması`)
};

const en_landing_shortcuts_stat_multipanel = /** @type {(inputs: Landing_Shortcuts_Stat_MultipanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`multi-panel search`)
};

const de_landing_shortcuts_stat_multipanel = /** @type {(inputs: Landing_Shortcuts_Stat_MultipanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panelübergreifende Suche`)
};

const ru_landing_shortcuts_stat_multipanel = /** @type {(inputs: Landing_Shortcuts_Stat_MultipanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поиск по всем панелям`)
};

/**
* | output |
* | --- |
* | "multi-panel search" |
*
* @param {Landing_Shortcuts_Stat_MultipanelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_stat_multipanel = /** @type {((inputs?: Landing_Shortcuts_Stat_MultipanelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Stat_MultipanelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_stat_multipanel(inputs)
	if (locale === "de") return de_landing_shortcuts_stat_multipanel(inputs)
	if (locale === "ru") return ru_landing_shortcuts_stat_multipanel(inputs)
	return tr_landing_shortcuts_stat_multipanel(inputs)
});